export const locale = {
    'APPROVAL': {
        'STATUS': {
            'APPROVED': 'Approved',
            'NOT_APPROVED': 'Not approved',
        }
    },
};